import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getProfilePictureUrl } from '../../../../../utils/pictureUrlCreator'

/**
 * @class ThreeChildView
 * @description Actionable Tabs to display your Students. Limited to 3 for ui concerns.
 */
class ThreeChildView extends Component {
  static propTypes = {
    activeStudentId: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    students: PropTypes.array.isRequired,
  }

  render() {
    const { activeStudentId, students, onClick } = this.props

    return (
      <div className="parent-tab-container-border">
        <div className="parent-tab-container">
          {students.map((item, index) => (
            <div
              key={index}
              onClick={onClick && (() => onClick(index))}
              className={`parent-tab ${item._id === activeStudentId ? 'active' : ''}`}
            >
              <img
                src={getProfilePictureUrl(item.profile.picture)}
                alt={item.fullName}
                className="parent-tab-image"
              />
              <h6 style={{marginBottom: 0}}>{item.fullName}</h6>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default ThreeChildView



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/components/ChildTabView/ThreeChildView.js